/* eslint-disable import/no-cycle */
import { Response as Client } from 'api/typegen/client/get';
import { Response as Client_Application } from 'api/typegen/client/application/get';
import digestMessage from 'hooks/eventCollector/hash';

export interface IIdentifyEvent {
  type: 'identify';
  timestamp: number;
  client?: Client;
  application?: Client_Application;
  email?: string;
  phone?: string;
  hasEmail: boolean;
  hasApplication: boolean;
  getHash(): Promise<string>;
}

export default class IdentifyEvent implements IIdentifyEvent {
  readonly type = 'identify' as const;

  readonly timestamp: number;

  readonly client?: Client;

  readonly application?: Client_Application;

  readonly email?: string;

  readonly phone?: string;

  constructor({
    client,
    application,
    email,
    phone,
  }: {
    client?: Client;
    application?: Client_Application;
    email?: string;
    phone?: string;
  }) {
    this.timestamp = new Date().getTime();
    if (client) {
      this.client = client;
    }
    if (application) {
      this.application = application;
    }
    if (email) {
      this.email = email;
    }
    if (phone) {
      this.phone = phone;
    }
  }

  get hasEmail() {
    if (this.email) {
      return true;
    }
    return false;
  }

  get hasApplication() {
    return !!this.application;
  }

  async getHash() {
    return digestMessage(this.email ?? '');
  }
}
